import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function Q2Conclusion() {
  const {
    lightColor, darkColor,
  } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            What does the data say?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <Typography variant="h5" gutterBottom>Do families have access to subsidized child care?</Typography>
                <Typography variant="body1">
                  The current child care subsidy system does not meet the needs of families with low incomes, or of child care programs. As a result, families who rely on subsidies have fewer child care options.
                </Typography>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubquestionBox>
  );
}

export default Q2Conclusion;
